export const bankReconciliationEn = {
  reconciled: `Reconciled`,
  unreconciled: `Unreconciled`,
  all_transactions_with_value: `All transactions ({{count}})`,
  reconciled_transactions_with_value: `Reconciled ({{count}})`,
  unreconciled_transactions_with_value: `Unreconciled ({{count}})`,
  reconciliation_source: `Reconciliation source`,
  source_type: `Source type`,
  select_records_to_match: `Select records to match`,
  select_records_to_match_transaction_amount_of: `Select records to match transaction amount of`,
  total_amount_of_reconciled_amount: `{{selectedReconcileAmount}} of {{totalReconcileAmount}}`,
  reconcile_transaction: `Reconcile transaction`,
  confirm_reconcile: `Are you sure you want to reconcile this transaction`,
  reconcile: `Reconcile`,
  bank_transaction_reconciled_successfully: `Bank transaction reconciled successfully`,
  transacted_on: `Transacted on`,
  unlink_transaction: `Unlink transaction`,
  view_reconciled_details: `View reconciled details`,
  unlink: `Unlink`,
  starting_balance: `Starting balance`,
  closing_balance: `Closing balance`,
  total_credit: `Total credit`,
  total_debit: `Total debit`,
  initial: `Initial`,
  increased: "Increased",
  decreased: "Decreased",
  transaction_summary: `Transaction summary`,
  invoice_summary: `Invoice summary`,
  credit_invoices: `Credit invoices`,
  outstanding: `Outstanding`,
  debit_invoices: `Debit invoices`,
  organization_payment_gateway_id_is_not_selected: `Please select bank and try again`,
  reconciled_status: "Reconciled status",
  payment_gateway: "Payment gateway",
  to_reconcile: `To reconcile`,
  transaction_reference: `Transaction reference`,
  date_range: `Date range`,
  reconciliation_candidates: `Reconciliation candidates`,
  no_candidates_found: `No candidates found`,
  no_transaction_to_reconcile: `No transaction to reconcile`,
  select_transaction_to_reconcile: `Select a transaction to view reconciliation candidates`,
  reconcile_transactions: `Reconcile transactions`,
  SaleInvoice: `Sale Invoice`,
  PurchaseInvoice: `Purchase Invoice`,
  PaymentDebit: `Payment Debit`,
  PaymentCredit: `Payment Credit`,
  selected_documents: `Selected documents`,
  left_to_reconcile: `Left to reconcile`,
  selected_candidates_amount_should_be_greater_than_0: `Selected candidates amount should be greater than 0`,
  selected_candidates: `Selected candidates`,
  reconcile_transaction_details: `Reconciled transaction details`,
  reconciled_payments: `Reconciled payments`,
  combined_amount: `Combined amount`,
  banktransaciton_unconcilled: `Bank transaction unconciled`,
  beneficiary_id: `Beneficiary Id`,
  remaining: `Remaining`,
  partial_reconciled: `Partial reconciled`,
  bank_transaction_unlinked_successfully: `Bank transaction unlinked successfully`,
  partial: `Partial`,
};
